import { useWrongNetwork } from '@/domain/hooks/useWrongNetwork'
import { track } from '@/features/analytics'
import { CommonDialogProps, DialogConfig } from '@/features/dialogs/common/types'
import { MyWalletProps } from '@/features/isolated-details/components/my-wallet/MyWallet'
import { IsolatedPairOverview } from '@/features/isolated-details/types'
import { Dialog, DialogContent } from '@/ui/atoms/dialog/Dialog'
import { useEffect, useRef } from 'react'
import { WithdrawDialogContentContainer } from './WithdrawDialogContentContainer'

export interface WithdrawDialogProps extends CommonDialogProps {
  walletOverview: MyWalletProps
  pairOverview?: IsolatedPairOverview
}

function WithdrawDialog({ open, setOpen, walletOverview, pairOverview }: WithdrawDialogProps) {
  const lastTrackedMarketAddress = useRef<string | undefined>(undefined)

  useEffect(() => {
    const marketAddress = pairOverview?.collateralAsset.address

    if (!pairOverview || lastTrackedMarketAddress.current === marketAddress) {
      return
    }

    lastTrackedMarketAddress.current = marketAddress
    track('lend_borrow_asset_selected', {
      token: String(pairOverview.collateralAsset.symbol),
      market: String(marketAddress),
      market_type: 'isolated',
      action_type: 'withdraw',
    })
  }, [pairOverview?.collateralAsset.address, pairOverview])

  const isWrongNetwork = useWrongNetwork()
  if (isWrongNetwork) {
    setOpen(false)
    return null
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent aria-describedby={undefined}>
        <WithdrawDialogContentContainer
          walletOverview={walletOverview}
          pairOverview={pairOverview}
          closeDialog={() => setOpen(false)}
        />
      </DialogContent>
    </Dialog>
  )
}

export const withdrawDialogConfig: DialogConfig<WithdrawDialogProps> = {
  options: {
    closeOnChainChange: true,
  },
  element: WithdrawDialog,
}
